import { render, staticRenderFns } from "./SendReminderControl.vue?vue&type=template&id=54125967&scoped=true"
import script from "./SendReminderControl.vue?vue&type=script&lang=js"
export * from "./SendReminderControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54125967",
  null
  
)

export default component.exports